import PropTypes from 'prop-types';

export default {
  centered: PropTypes.bool,
  showDate: PropTypes.bool,
  flights: PropTypes.arrayOf(PropTypes.object),
  selectedRoute: PropTypes.object,
  selectedTrip: PropTypes.object,
  TabContent: PropTypes.object,
  toggleRoutes: PropTypes.func,
  isMain: PropTypes.bool,
  classes: PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/containers/routeTabs/RouteTabsProps.js